import { ReactNode } from 'react';

import { Chip } from '@braskai/ui-kit';
import { useNavigate } from 'react-router-dom';

import { ListItemIcon, ListItemProps } from '@mui/material';

import { SListItem, SListItemButton, SListItemText } from './styled';

export type NavigationItemAction = {
  title: string;
  dataTestId?: string;
  onClick: () => void;
};

export type NavigationItemProps = {
  title?: string;
  action?: NavigationItemAction;
  'data-testid'?: string;
  dataTestId?: string;
  icon?: ReactNode;
  isDisabled?: boolean;
  isMainMenu?: boolean;
  isMobile?: boolean;
  isOutlined?: boolean;
  isSquare?: boolean;
  navigationState?: Record<string, unknown>;
  path?: string;
  rightText?: string;
  selected?: boolean;
  spotlightAnchor?: string;
  tag?: ReactNode | string;
  onClick?: () => void;
} & ListItemProps;

export const NavigationItem = ({
  title,
  action: _action,
  'data-testid': dataTestIdAttribute,
  dataTestId,
  icon,
  isDisabled = false,
  isMainMenu,
  isMobile = false,
  isOutlined = false,
  isSquare = false,
  navigationState,
  path,
  rightText,
  selected = false,
  spotlightAnchor: _spotlightAnchor,
  tag,
  onClick,
  ...props
}: NavigationItemProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (path) {
      if (navigationState) navigate(path, { state: navigationState });
      else navigate(path);
    }

    onClick?.();
  };

  return (
    <SListItem key={path} disablePadding {...props}>
      <SListItemButton
        $isDisabled={isDisabled}
        $isMainMenu={isMainMenu}
        $isMobile={isMobile}
        $isOutlined={isOutlined}
        $isSquare={isSquare}
        data-testid={dataTestIdAttribute ?? dataTestId}
        selected={selected}
        onClick={handleClick}
      >
        {icon && <ListItemIcon>{icon}</ListItemIcon>}
        {title && <SListItemText primary={title} secondary={rightText} />}
        {tag && <Chip label={tag} color="primary" size="md" />}
      </SListItemButton>
    </SListItem>
  );
};
